import Snackbar from 'components/Snackbar/Snackbar'
import React, { useCallback, useState } from 'react'
import { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { SNACKBAR_MESSAGE } from 'core/store/global'

interface SectionSnackbarProps {}

const SectionSnackbar: React.FC<SectionSnackbarProps> = (props) => {
  const [snackbarMessage, setSnackbarMessage] = useRecoilState(SNACKBAR_MESSAGE)
  const [message, setMessage] = useState<string | null>(snackbarMessage)
  const [timer, setTimer] = useState<NodeJS.Timeout>()

  const closeSnackbar = useCallback(() => {
    setSnackbarMessage(null)
    setMessage(null)
  }, [setSnackbarMessage])

  useEffect(() => {
    if (!snackbarMessage) return
    /* 이전 타이머가 있으면 해지 */
    if (timer) clearTimeout(timer)
    setMessage(snackbarMessage)
    setSnackbarMessage(null)

    const timeoutId = setTimeout(() => {
      closeSnackbar()
    }, 3000)

    setTimer(timeoutId)
  }, [timer, snackbarMessage, closeSnackbar, setSnackbarMessage])

  if (!message) return null

  return <Snackbar key={Math.random()} message={message} onClickButton={closeSnackbar} />
}

export default SectionSnackbar
